<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Name</th>
            <td>{{ item['name'] }}</td>
          </tr>
          <tr>
            <th scope="row">Created</th>
            <td>{{ item['created'] }}</td>
          </tr>
          <tr>
            <th scope="row">Youtube video id</th>
            <td>{{ item['youtubeVideoId'] }}</td>
          </tr>
          <!-- <tr>
            <th scope="row">speaker</th>
            <td>{{ item['speaker'] }}</td>
          </tr> -->
          <tr>
            <th scope="row">Speaker</th>
            <td v-if="item['speaker'] != null">
              {{ item['speaker'].name }}
            </td>
            <td v-else>
            </td>
          </tr>          
          <tr>
            <th scope="row">Testimonials</th>
            <td v-if="item['testimonials'] != ''">
               <router-link                
                :to="{ name: 'TestimonialListVideo', params: { id: item['id'] }}">
                {{ item['testimonials'].length }}
              </router-link></td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'VideoList' }"
      class="btn btn-primary">
      Back to list
    </router-link>
    <router-link
      v-if="item"
      :to="{ name: 'VideoUpdate', params: { id: item['@id'] } }"
      class="btn btn-warning">
      Edit
    </router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {      
    }
  },
  computed: {
    ...mapFields('video/del', {
      deleteError: 'error',
    }),
    ...mapFields('video/show', {
      error: 'error',
      isLoading: 'isLoading',
      item: 'retrieved',
    }),   
    ...mapFields('speaker/list', {
      'speakerSelectItems': 'selectItems',
    }),
  },

  beforeDestroy () {
    this.reset();
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },

  methods: {
    ...mapActions({
      del: 'video/del/del',
      reset: 'video/show/reset',
      retrieve: 'video/show/retrieve',
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'VideoList' }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/video/Show.vue